/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrdersForPrintDto as DigiworkMaitreDPosDtoOrderV2OrdersForPrintDto } from '../../models/Digiwork/MaitreD/Pos/DTO/OrderV2/orders-for-print-dto';

export interface GetOrderForPrint$Params {
  orderId: string;
}

export function getOrderForPrint(http: HttpClient, rootUrl: string, params: GetOrderForPrint$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoOrderV2OrdersForPrintDto>> {
  const rb = new RequestBuilder(rootUrl, getOrderForPrint.PATH, 'get');
  if (params) {
    rb.path('orderId', params.orderId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoOrderV2OrdersForPrintDto>;
    })
  );
}

getOrderForPrint.PATH = '/api/orders/{orderId}';
